module.exports = __webpack_public_path__ + "banquet/components/images/pro_badge.0bdd6280b9f897f4b04014e22428412d.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/pro_badge.svg
// module id = 1040
// module chunks = 1